module.exports = __webpack_public_path__ + "img/logo.4fc7a98d.svg";